import { SettingOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const SettingsButton = styled(SettingOutlined)`
  position: absolute;
  top: 1%;
  right: 1%;
  font-size: 30px;
  color: #e6e6e6;
`;
